class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/company-pager`;
    }
    /**
     * Creates and sends an internal text message (company pager message).
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/company-pager
     * Rate Limit Group: Medium
     * App Permission: InternalMessages
     * User Permission: InternalSMS
     */
    async post(createInternalTextMessageRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), createInternalTextMessageRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
